module.exports = __webpack_public_path__ + "static/media/Isospora.c1145850.JPG";